import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// When the page is served from the same domain the backend URL points at
// (apex and www count as the same domain), call the API on the current
// origin so apex<->www redirects can never break form submissions.
const sameOrigin = (() => {
  try {
    if (!BACKEND_URL || typeof window === "undefined") return false;
    const strip = (h) => h.replace(/^www\./, "");
    return strip(new URL(BACKEND_URL).host) === strip(window.location.host);
  } catch {
    return false;
  }
})();

export const API = sameOrigin ? "/api" : `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
